<div class="row">
    <app-card [hidHeader]="false" cardTitle="Programa Cadastrado" [options]="false" class="col-sm-12" id="inicioPagina">
    
       
       
      <div class="row">
        <div class="col-sm-6 col-xl-3">
          <label class="sub-title">Descricão</label>
          <input type="text" class="form-control"  name="appFacebook" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-9">
          <label class="sub-title">Área de Implementação</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        
      </div>
  
      <div class="row">
        <div class="col-sm-6 col-xl-3">
          <label class="sub-title">Data de Inicio</label>
          <input type="text" class="form-control"  name="appFacebook" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-3">
          <label class="sub-title">Duração Estimada</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-3">
          <label class="sub-title">Equipe Responsável</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-3">
          <label class="sub-title">Indicadores de Desempenho</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-4">
          <label class="sub-title">Metas Estabelecidas</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-4">
          <label class="sub-title">Ações Implementadas</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-4">
          <label class="sub-title">Status Atual</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-6">
          <label class="sub-title">Resultados Alcançados</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-6">
          <label class="sub-title">Plano de Sustentabilidade</label>
          <input type="file" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-12">
          <label class="sub-title">Recursos Investidos</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        <div class="col-sm-6 col-xl-12">
          <label class="sub-title">Feedback dos Participantes</label>
          <input type="text" class="form-control"  name="token" placeholder="">
        </div>
        
      </div>
  
      <br>  <br>
      <div class="row">
        <div class="col-sm-12 ">
          <button type="button" class="btn btn-warning float-left " (click)="voltar()">
            <i class="feather icon-arrow-left mr-2 f-18"></i>
            Voltar
          </button>
          <button type="button" class="btn btn-primary float-right " (click)="salvar()">
            <i class="feather icon-check-circle mr-2 f-18"></i>
            Salvar
          </button>
        </div>
      </div>
    </app-card>
  </div>
  